import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ChainedBackend from 'i18next-chained-backend'
import HttpApi from 'i18next-http-backend'
import LocalStorageBackend from 'i18next-localstorage-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import * as locales from '../../../i18n'
import env from '../../../config/env'

const langKey = 'yolda_lang'

class LanguageHelper {
  updateMetaDescrtiption() {
    try {
      if (!i18n.t('document.title')) {
        return
      }

      document.title = i18n.t('document.title')
      const meta = document.querySelector('meta[name="description"]') as HTMLElement
      meta.setAttribute('content', i18n.t('document.description'))
    } catch (err) {
      console.error(err)
    }
  }

  init() {
    i18n
      .use(ChainedBackend)
      .use(initReactI18next)
      .init({
        lng: this.get(),
        fallbackLng: 'en',
        load: 'currentOnly',
        cleanCode: true,
        backend: {
          backends: [LocalStorageBackend, HttpApi, resourcesToBackend(locales)],
          backendOptions: [
            {
              expirationTime: 10 * 1000,
            },
            {
              loadPath: `${env.translationUrl}/translations/carrier/{{lng}}.json`,
              parse(data: string) {
                return JSON.parse(data).translation
              },
            },
          ],
        },
      })
  }

  change(lang: string) {
    localStorage.setItem(langKey, lang)
    i18n.changeLanguage(lang)
    const html = document.querySelector('html') as HTMLElement
    html.lang = lang
    this.updateMetaDescrtiption()
  }

  get() {
    this.updateMetaDescrtiption()
    const cacheLang = localStorage.getItem(langKey)
    const browserLang = (window?.navigator?.language || '-').split('-')[0]
    return i18n?.language || cacheLang || browserLang
  }
}

export default new LanguageHelper()
